module.exports = __webpack_public_path__ + "media/icons/png-file-22d22d73.png";